import { GeneralModel } from "./general.model";

export class Formula extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/formula.model.ts